<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchParams" :model="searchParams" label-width="120px"
                     class="unitWidth" size="small">
                <el-form-item :label="$t('Shift.factory')">
                    <el-select v-model="fcCode" :placeholder="$t('base.PleaseSelect')" :clearable="isclear" filterable :disabled="ischeck"
                               @change="fcChange">
                        <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName"
                                   :value="factory.fcCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Branch.BranchName')">
                    <el-select v-model="depNo" :placeholder="$t('base.PleaseSelect')" clearable :disabled="sectionOfficeShow">
                        <el-option v-for="factory in branchData" :key="factory.sdepId" :label="factory.depName"
                                   :value="factory.depNo"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Department.DepartmentCode')">
                    <el-input v-model="ssoNo" :placeholder="$t('base.PleaseEnter')" :disabled="sectionOfficeShow"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Department.DepartmentName')">
                    <el-input v-model="fcIdSelected" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
            </el-form>
            <template slot="btns">
                <div style="float:right; margin-top:5px">
                    <el-button size="small" type="primary" @click="searchTable">{{$t('base.search')}}</el-button>
                    <el-button size="small" @click="clearSelect">{{$t('base.Reset')}}</el-button>
                </div>
            </template>
        </SearchBox>
        <LabelContent :title="$t('Department.DepartmentList')" ref="LabelContent">
            <div slot="btns">
                <!-- <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <span v-for="acc in access" :key="acc">
                    <el-button size="small" type="success" v-if="acc=='KESHI001'" @click=";(ifAdd = true), updatehOpen()" style="margin-right: 10px">
                        {{$t('base.add')}}
                    </el-button>
                    <el-button size="small" type="success" v-if="acc=='KESHI004'" @click="sectionOfficeTemplate" style="margin-right: 10px">
                        {{$t('base.Mould')}}
                    </el-button>
                    <el-button size="small" type="success" v-if="acc=='KESHI005'" @click="sectionOfficeImport()">
                        {{$t('base.Import')}}
                    </el-button>
                </span>
                <!-- <el-button size="small" type="success" @click="exportShift">导出</el-button> -->
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column type="index" :label="$t('base.order')" show-overflow-tooltip width="60"/>
                <el-table-column prop="fcName" :label="$t('Shift.factory')" show-overflow-tooltip/>
                <el-table-column prop="depName" :label="$t('Branch.BranchName')" show-overflow-tooltip/>
                <el-table-column prop="ssoNo" :label="$t('Department.DepartmentCode')" show-overflow-tooltip/>
                <el-table-column prop="ssoName" :label="$t('Department.DepartmentName')" show-overflow-tooltip/>
                <el-table-column :label="$t('base.operation')" width="100">
                    <template slot-scope="scope">
                      <span v-for="acc in access" :key="acc">
                        <!--<i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
                        <i class="document el-icon-more" v-if="acc=='KESHI002'" @click="toStaff(scope.row)"/>
                        <i class="delBtn iconfont u-shanchu" v-if="acc=='KESHI003'" @click="deleteRow(scope.row)"/>
                      </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
        <el-dialog :title="ifAdd ? $t('base.add') : $t('base.update')" width="500px" :visible.sync="updateShow" style="text-align: left">
            <el-form :model="shiftForm" :rules="rules" ref="shiftForm" label-width="100px" class="demo-roleForm">
                <el-form-item style="display: flex; justify-content: center; margin-left: 18px" :label="$t('Branch.BranchName')"
                              prop="sdepId" label-width="120">
                    <el-select style="margin-left: 2.5vw" v-model="shiftForm.sdepId" :placeholder="$t('base.PleaseSelect')" filterable
                               @change="selectChange">
                        <el-option v-for="factory in branchData" :key="factory.sdepId" :label="factory.depName"
                                   :value="factory.sdepId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="display: flex; justify-content: center; margin-left: 18px" :label="$t('Department.DepartmentCode')"
                              prop="ssoNo" label-width="120">
                    <el-input style="margin-left: 2.5vw" v-model="shiftForm.ssoNo" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item style="display: flex; justify-content: center; margin-left: 18px" :label="$t('Department.DepartmentName')"
                              prop="ssoName" label-width="120">
                    <el-input style="margin-left: 2.5vw" v-model="shiftForm.ssoName" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateShow = false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary" @click="updateShift('shiftForm')">{{ ifAdd ? $t('base.add') : $t('base.update') }}</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="$t('Department.DepartmentImport')" :visible.sync="sectionOfficeImportShow">
            <el-upload
                class="upload-demo"
                drag
                :headers="{'X-Auth-Token':token}"
                :action="URL"
                :on-success="itemSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">{{$t('msg.Drag')}} <em>{{$t('msg.Upload')}}</em></div>
            </el-upload>
        </el-dialog>
    </div>
</template>

<script>
    import jQuery from 'jquery'
    import { getDeptSectionLiableUser, sectionOfficeImport } from '../../../libs/api'

    export default {
        name: 'shiftList',
        data() {
            return {
                depNo: '',
                ssoNo: '',
                updateShow: false,
                ifAdd: false,
                userInfo: {},
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                fcIdSelected: '',
                factoryTree: [],
                tableData: [],
                shiftForm: {
                    sdepId: String,
                    ssoName: String,
                    ssoNo: String
                },
                rules: {
                    sdepId: [
                        {
                            required: true,
                            message: this.$t('base.PleaseSelect'),
                            trigger: 'change'
                        }
                    ],
                    ssoName: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ],
                    ssoNo: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ],
                    sfStartHour: [
                        {
                            required: true,
                            message: '班次开始时间（时）',
                            trigger: 'blur'
                        }
                    ],
                    sfStartMinute: [
                        {
                            required: true,
                            message: '班次开始时间（分）',
                            trigger: 'blur'
                        }
                    ],
                    sfEndHour: [
                        {
                            required: true,
                            message: '班次结束时间（时）',
                            trigger: 'blur'
                        }
                    ],
                    sfEndMinute: [
                        {
                            required: true,
                            message: '班次结束时间（分）',
                            trigger: 'blur'
                        }
                    ]
                },
                factoryData: [],
                branchData: [],
                access: [],
                role: [],
                ischeck: true,
                scopeDisabled: '',
                isclear: false,
                factoryList: [],
                fcCode: '',
                sectionOfficeImportShow: false,
                URL: '',
                token: '',
                sectionOfficeInfo: {},
                sectionOfficeShow: false
            }
        },
        mounted() {
            this.access = JSON.parse(sessionStorage.getItem('auths'))
            // this.userInfo = sessionStorage.getItem("userInfo")
            this.userInfo = this.$store.state.userInfo
            this.token = sessionStorage.getItem('authToken')
            var role = this.userInfo.roles
            for (var i = 0; i < role.length; i++) {
                //所有工厂数据
                if (role[i].factoryId == 0) {
                    this.ischeck = false
                    this.role = role[i]
                    this.scopeDisabled = false
                    this.isclear = true
                    break
                } else {
                    if (this.userInfo.factoryId == role[i].factoryId) {
                        this.role = role[i]
                    }
                }
            }
            // this.getData()
            this.getFactory()
        },
        methods: {
            getBranch() {
                if (!this.fcCode) {
                    return
                }
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.getAllBranch,
                    params: {
                        fcCode: this.fcCode
                    }
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        self.branchData = response.data
                    }
                })
            },
            toStaff(val) {
                this.$router.push({
                    name: 'staff',
                    params: {
                        row: val
                    }
                })
            },
            clearSelect() {
                this.fcIdSelected = ''
                this.depNo = ''
                this.ssoNo = ''
                this.searchTable()
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    // for (var i = 0;i < self.factoryTree.length;i++) {
                    //   if (self.factoryTree[i].deptID == self.role.factoryId) {
                    //     self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                    //   }
                    // }
                })
            },
            getFactory() {
                let options = {
                    methods: 'GET',
                    url: this.$api.getAllFactory
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryList = []
                        var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                        var aa = response.data
                        if (this.ischeck) {
                            for (var i = 0; i < aa.length; i++) {
                                for (let j = 0; j < userInfo.roles.length; j++) {
                                    if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                                        this.factoryList.push(aa[i])
                                        this.fcCode = this.userInfo.fcCode
                                    }
                                }
                            }
                        } else {
                            this.factoryList = response.data
                        }
                    }
                    this.getBranch()
                    this.getDeptSectionLiableUser()
                })
            },
            fcChange() {
                this.depNo = ''
                this.branchData = []
                this.getBranch()
                this.searchTable()
            },
            //科室导入模板
            sectionOfficeTemplate() {
                if (!this.fcCode) {
                    this.$message.error(this.$t('mechanism.selectFc'))
                    return
                }
                var inputs = ''
                var lang = this.$t('lang')
                inputs += '<input type="hidden" name="token" value="' + this.token + '" />'
                inputs += '<input type="hidden" name="language" value="' + lang + '" />'
                if (this.fcCode != '' && this.fcCode != undefined) {
                    inputs += '<input type="hidden" name="fcCode" value="' + this.fcCode + '" />'
                }
                var url = this.$api.sectionOfficeTemplate
                jQuery('<form action="' + url + '" method=POST>' + inputs + '</form>')
                    .appendTo('body').submit().remove()
            },
            //科室导入
            sectionOfficeImport(){
                if (!this.fcCode) {
                    this.$message.error(this.$t('mechanism.selectFc'))
                    return
                }
                if(this.fcCode != '' && this.fcCode != undefined ) {
                    this.sectionOfficeImportShow = true
                    this.URL = this.$api.sectionOfficeImport + '?fcCode=' + this.fcCode + '&language=' + this.$t('lang')
                }
            },
            itemSuccess(resp){
                if (resp.status == 100) {
                    this.$message.success(this.$t('base.ImportSucceeded'))
                    this.sectionOfficeImportShow = false
                    this.searchTable()
                } else {
                    alert(resp.message)
                }
            },
            getDeptSectionLiableUser() {
                this.sectionOfficeShow = false
                let options = {
                    methods: 'GET',
                    url: this.$api.getDeptSectionLiableUser,
                    params: {
                        fcCode: this.fcCode,
                        userAccount: this.userInfo.userAccount
                    }
                }
                let self = this
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data) {
                            let sectionOfficeInfo = response.data
                            self.depNo = sectionOfficeInfo.depNo
                            self.ssoNo = sectionOfficeInfo.ssoNo
                            self.sectionOfficeShow = true
                        }
                        self.searchTable()
                    }
                })
            },
            /**
             *查询用户列表
             *  查询参数对象 searchParams
             **/
            searchTable() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                if (this.fcCode != undefined && this.fcCode != '') {
                    queryParams['fcCode'] = this.fcCode
                }
                if (this.depNo != null && this.depNo != '') {
                    queryParams['depNo'] = this.depNo
                }
                if (this.ssoNo != null && this.ssoNo != '') {
                    queryParams['ssoNo'] = this.ssoNo
                }
                if (this.fcIdSelected != null && this.fcIdSelected != '') {
                    queryParams['ssoName'] = this.fcIdSelected
                }
                let options = {
                    method: 'GET',
                    params: queryParams,
                    url: this.$api.getDepart
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            updatehOpen(row) {
                if (!this.fcCode) {
                    this.$message.error(this.$t('mechanism.selectFc'))
                    return
                }
                if (this.ifAdd) {
                    //新增
                    this.shiftForm = {}
                    // if (this.ischeck) {
                    //   this.shiftForm.fcCode = this.userInfo.fcCode
                    // }
                    this.updateShow = true
                } else {
                    //编辑
                    this.shiftForm = JSON.parse(JSON.stringify(row))
                    this.updateShow = true
                }
            },
            updateShift(shiftForm) {
                if (this.ifAdd) {
                    this.$refs[shiftForm].validate((valid) => {
                        if (valid) {
                            let options = {
                                method: 'POST',
                                showLoading: true,
                                url: this.$api.addDepart,
                                data: this.shiftForm
                            }
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    this.$message.success(this.$t('base.SuccessfullyAdded'))
                                    this.updateShow = false
                                    this.searchTable()
                                } else {
                                    this.$message.error(response.message)
                                }
                            })
                        } else {
                            return false
                        }
                    })
                } else {
                    this.$refs[shiftForm].validate((valid) => {
                        if (valid) {
                            let options = {
                                method: 'POST',
                                showLoading: true,
                                url: this.$api.editDepart,
                                data: this.shiftForm
                            }
                            this.$http.request(options).then(response => {
                                if (response.status == 100) {
                                    this.$message.success(this.$t('base.SuccessfullyUpdated'))
                                    this.updateShow = false
                                    this.searchTable()
                                } else {
                                    this.$message.error(response.message)
                                }
                            })
                        } else {
                            return false
                        }
                    })
                }
            },
            selectChange() {
                this.$forceUpdate()
            },
            deleteRow(row) {
                this.$confirm(this.$t('msg.longTips'), this.$t('msg.Tips'), {
                    confirmButtonText: this.$t('base.delete'),
                    cancelButtonText: this.$t('base.cancel'),
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                headers: { 'content-type': 'application/json' },
                                params: { ssoId: row.ssoId },
                                url: this.$api.delDepart
                            })
                            .then(response => {
                                this.searchTable()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.searchTable()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        //   this.searchTable()
                        this.$message({
                            type: 'info',
                            message: this.$t('msg.cancel')
                        })
                    })
            },
            async exportShift() {
                let params = {}
                if (this.fcIdSelected != null && this.fcIdSelected != '') {
                    params['fcCode'] = this.fcIdSelected
                }
                let options = {
                    url: this.$api.exportShift,
                    method: 'POST',
                    params: params,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = '班次信息'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            }
        }
    }
</script>

<style scoped>
</style>
